import type { ReactNode } from 'react';
import { CampoDeSenha } from './CampoDeSenha.js';

/**
 * Par "nova senha" + "repita", com a política do pool escrita por extenso.
 *
 * Existe em três lugares — primeiro acesso, senha esquecida e troca voluntária — e a
 * política é a mesma nos três. Repetir os campos convidaria a repetir a regra, e regra
 * repetida é regra que diverge: bastaria alguém mudar `minLength` no CDK para uma das
 * telas passar a mentir.
 */
export const REGRA_DA_SENHA = 'Ao menos 12 caracteres, com maiúscula, minúscula, número e símbolo.';

/** Confere só o que dá para conferir aqui; o Cognito é quem decide de verdade. */
export function problemaDaSenha(nova: string, confirmacao: string): string | null {
  if (nova.length < 12) return REGRA_DA_SENHA;
  if (!/[a-z]/.test(nova) || !/[A-Z]/.test(nova)) return REGRA_DA_SENHA;
  if (!/\d/.test(nova)) return REGRA_DA_SENHA;
  if (!/[^A-Za-z0-9]/.test(nova)) return REGRA_DA_SENHA;
  if (nova !== confirmacao) return 'As duas senhas precisam ser iguais.';
  return null;
}

interface Props {
  nova: string;
  confirmacao: string;
  aoMudarNova: (v: string) => void;
  aoMudarConfirmacao: (v: string) => void;
  /** Prefixo dos ids, para as telas que têm mais de um formulário na página. */
  prefixo?: string;
  dica?: ReactNode;
}

export function CamposDeNovaSenha({
  nova,
  confirmacao,
  aoMudarNova,
  aoMudarConfirmacao,
  prefixo = 'senha',
  dica,
}: Props) {
  return (
    <>
      <CampoDeSenha
        id={`${prefixo}-nova`}
        rotulo="Nova senha"
        valor={nova}
        aoMudar={aoMudarNova}
        autoComplete="new-password"
        dica={dica ?? REGRA_DA_SENHA}
      />
      <CampoDeSenha
        id={`${prefixo}-confirmacao`}
        rotulo="Repita a nova senha"
        valor={confirmacao}
        aoMudar={aoMudarConfirmacao}
        autoComplete="new-password"
      />
    </>
  );
}
